import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useGDLData } from './useGDLData';

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function GDLStocks() {
  const nav = useNavigate();
  const { stocks, csId, refresh } = useGDLData();
  const [fundAmt, setFundAmt] = useState('');
  const [msg, setMsg] = useState('');

  if (!csId) { nav('/demo/gdl/login'); return null; }
  if (!stocks) return <SkeletonStocks />;

  const fund = async () => {
    try {
      await axios.post(`${API}/api/demo/gdl/stocks/fund/${csId}`, { amount: parseFloat(fundAmt) }, { withCredentials: true });
      setFundAmt(''); refresh(); setMsg('');
    } catch (e) { setMsg(e.response?.data?.detail || 'Failed'); }
  };

  return (
    <div style={{ padding: '12px 16px 24px', display: 'flex', flexDirection: 'column', gap: 18 }}>
      <div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#2D0A10', letterSpacing: '-0.02em' }}>Stocks</div>
        <div style={{ fontSize: 14, color: '#A07078', marginTop: 2 }}>Trade Nigerian equities</div>
      </div>

      {/* Summary Cards */}
      <div style={{ display: 'flex', gap: 10 }}>
        <div style={{
          flex: 1, borderRadius: 18, padding: '18px 16px',
          background: 'linear-gradient(145deg, #C43B4D, #8E2233)',
          boxShadow: '0 4px 20px rgba(176,49,64,0.3)',
        }}>
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Portfolio Value</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#fff', marginTop: 4 }} data-testid="portfolio-value">
            {'\u20A6'}{stocks.total_value.toLocaleString()}
          </div>
        </div>
        <div style={{
          flex: 1, background: '#fff', borderRadius: 18, padding: '18px 16px',
          boxShadow: '0 2px 10px rgba(176,49,64,0.06)',
        }}>
          <div style={{ fontSize: 10, color: '#A07078', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Trading Balance</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#2D0A10', marginTop: 4 }} data-testid="trading-balance">
            {'\u20A6'}{stocks.trading_balance.toLocaleString()}
          </div>
        </div>
      </div>

      {/* Holdings */}
      <div>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#2D0A10', marginBottom: 10 }}>Holdings</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {stocks.portfolio.map(s => (
            <div key={s.ticker} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '14px 18px', background: '#fff', borderRadius: 16,
              boxShadow: '0 1px 6px rgba(176,49,64,0.04)',
            }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#2D0A10' }}>{s.company_name}</div>
                <div style={{ fontSize: 12, color: '#A07078', marginTop: 2 }}>{s.ticker} {'\u00B7'} {s.units} units</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#2D0A10' }}>{'\u20A6'}{s.current_price.toLocaleString()}</div>
                <div style={{ fontSize: 12, fontWeight: 700, color: s.gain_loss_pct >= 0 ? '#10B981' : '#EF4444', marginTop: 1 }}>
                  {s.gain_loss_pct >= 0 ? '+' : ''}{s.gain_loss_pct}%
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Fund Trading */}
      <div style={{ background: '#fff', borderRadius: 20, padding: '18px', boxShadow: '0 2px 12px rgba(176,49,64,0.06)' }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#2D0A10', marginBottom: 12 }}>Fund Trading Account</div>
        <input type="number" value={fundAmt} onChange={e => setFundAmt(e.target.value)}
          placeholder="Amount to fund" style={inp} data-testid="fund-trading-amount" />
        <button onClick={fund} disabled={!fundAmt} data-testid="fund-trading-btn" style={{
          ...btn, marginTop: 10, opacity: !fundAmt ? 0.5 : 1,
        }}>
          Fund Trading Account
        </button>
        {msg && <div style={{ fontSize: 13, color: '#EF4444', fontWeight: 600, marginTop: 8 }}>{msg}</div>}
        <div style={{ fontSize: 11, color: '#A07078', textAlign: 'center', marginTop: 14 }}>
          Powered by GDL Stockbrokers {'\u00B7'} Regulated by SEC & NSE
        </div>
      </div>
    </div>
  );
}

function SkeletonStocks() {
  return (
    <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div><div className="gdl-skeleton" style={{ width: '30%', height: 20 }} /><div className="gdl-skeleton" style={{ width: '50%', height: 12, marginTop: 4 }} /></div>
      <div style={{ display: 'flex', gap: 10 }}><div className="gdl-skeleton" style={{ width: '50%', height: 80, borderRadius: 18 }} /><div className="gdl-skeleton" style={{ width: '50%', height: 80, borderRadius: 18 }} /></div>
      {[1,2,3].map(i => <div key={i} className="gdl-skeleton" style={{ width: '100%', height: 60, borderRadius: 16 }} />)}
    </div>
  );
}

const inp = { width: '100%', padding: '14px 16px', border: '1.5px solid rgba(176,49,64,0.12)', borderRadius: 12, fontSize: 15, outline: 'none', boxSizing: 'border-box', background: 'rgba(176,49,64,0.03)', color: '#2D0A10' };
const btn = { width: '100%', padding: '15px', background: '#B03140', color: '#fff', border: 'none', borderRadius: 14, fontSize: 15, fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 16px rgba(176,49,64,0.2)' };
